import React from 'react'
import ThumbsUpText from './ThumbsUpText'

export default function Info() {

  return (
    <div className='contentbox'>
        <ThumbsUpText text={"Startups create a world that actually is better."} text2={"Any problem that can be solved, will be solved"} text3={"by a startup, and that is a huge opportunity."}/>
    </div>
  )
}
